export const powerOnIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path stroke="currentColor" stroke-linecap="round" stroke-width="1.6" d="M4.5 5.43a5 5 0 1 0 7 0M8 2v5"/></svg>`,
    name: 'power-on' as const
};